export default __webpack_public_path__ + "static/media/ico-sq-10-inequality.8ebc197b.svg";